import { Button } from "@novaescola/eva-react-v2/lib/Button";
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import React, { useState } from "react";
import { sanitizeHtml } from "../../utils/sanitize";
import clockImg from "../../images/clock.png";
import configImg from "../../images/config.png";
import collegeImg from "../../images/college.png";
import neImg from "../../images/ne.png";
import checkImg from "../../images/check.png";
import dialogImg from "../../images/dialog.png";
import PhoneModal from "./PhoneModal";

export function CallToActionSection ({ section, pageTitle, user }) {
	const coloButton = section.body?.textColor === '#FFFFFF' || section.body?.textColor === '#ffffff' ? "black" : "white";
	const location = window.location.pathname;
	const validUrl = location === "/tudo-sobre/planos-de-aula-por-whatsapp/";
	const { btnPrimaryBackground, btnPrimaryText } = section.body || {};
	const [showModal, setShowModal] = useState(false)
	const [linkRedirect, setLinkRedirect] = useState("")
	const [name, setName] = useState("")

	const cards = [
		{ 
			alt: "clock",
			icon: clockImg,
			title: "Economia de tempo",
			subtitle: "Receba planos de aula completos e personalizados em até 1 minuto, direto no seu WhatsApp."
		},
		{
			alt: "config",
			icon: configImg,
			title: "Adaptação fácil",
			subtitle: "Adapte o plano conforme sua necessidade, contexto da turma e recursos disponíveis."
		},
		{
			alt: "college",
			icon: collegeImg,
			title: "Alinhado à BNCC",
			subtitle: "Todos os planos são criados seguindo as diretrizes da Base Nacional Comum Curricular."
		},
		{
			alt: "novaescola-icon",
			icon: neImg,
			title: "Confiança Nova Escola",
			subtitle: "Assim como todas as nossas soluções, feita de professor para professor.",
		},
		{
			alt: "check",
			icon: checkImg,
			title: "Totalmente gratuito",
			subtitle: "Solução 100% gratuita da Nova Escola para apoiar professores das escolas públicas no Brasil."
		},
		{
			alt: "dialog",
			icon: dialogImg,
			title: "Simples de usar",
			subtitle: "Fácil de usar a qualquer hora e lugar. Basta enviar uma mensagem e seguir o passo a passo."
		}
	]

	return (
		<>
			<section className="container-fluid eva-bg-inst-500 eva-color-branco" style={{ backgroundColor: section.body?.backgroundColor }}>
				<div className="container container-blocks">
					<div className="blocks eva-text-center">
						<Typography variant="title" size={4} asChild
							className="eva-margin-bottom-2"
							style={{ color: section.body?.textColor }}
						>
							<p>{section.body?.title}</p>
						</Typography>

						<Typography variant="body" size={1} asChild
							className={`${!!section.body?.buttonText && "eva-margin-bottom-4"}`}
							style={{ color: section.body?.textColor }}
						>
							<div
								dangerouslySetInnerHTML={{
									__html: section.body?.subtitle ? 
										sanitizeHtml(section.body?.subtitle) 
										: '',
								}}
							/>
						</Typography>

						{!!section.body?.buttonText && (
							<Button 
								asChild
								size="medium" 
								color={coloButton} 
								style={{...(btnPrimaryBackground && { 
										backgroundColor: btnPrimaryBackground 
									}) 
								}}
								onClick={async (e) => {
									if (section.body?.sendPdfWhatsappPrimaryButton) {
										e.preventDefault()
										setLinkRedirect(section.body?.buttonLink)
										setName(section.body?.title)
										setShowModal(true)
										return
									}
								}}
							>
								<a
									type="button"
									target="_self"
									rel="noreferrer"
									className="eva-margin-center"
									href={section.body?.sendPdfWhatsappPrimaryButton ? undefined : section.body?.buttonLink}
									style={{...(btnPrimaryText && { color: btnPrimaryText }) }}
									data-track={`SITE: Click - ${pageTitle} - seção chamada - ${section.body?.title}`}
								>
									{section.body?.buttonText}
								</a>
							</Button>
						)}
						{(validUrl && section.body?.title === "Por que usar o WhatsApp da Nova Escola?") && 
							<div className="container-cards-info d-flex ai-center jc-center fw-wrap">
								{cards.map((card, index) => (
										<div key={index} className="card-info">
												<img src={card.icon} alt={card.alt} width={40} height={40}/>
												<Typography variant="title" size={5} className="eva-margin-bottom-2">
													{card.title}
												</Typography>
												<Typography variant="body" className="eva-margin-bottom-4">
													{card.subtitle}
												</Typography>
										</div>
									))
								}
							</div>
						}
					</div>
				</div>
				{showModal && <PhoneModal user={user} linkRedirect={linkRedirect} onClose={() => setShowModal(false)} name={name || section.body?.title} />}
			</section>
		</>
	)
}